import MainLayout from '../components/user/MainLayout'
import Dashboard from '../components/user/Dashboard'
import BookingUpComingEvent from '../components/user/BookingUpComingEvent'
import Message from '../components/user/Message'
import MessageDetail from '../components/user/MessageDetail'
import AlbumLIsts from '../components/user/AlbumLIsts'
import AlbumDetail from '../components/user/AlbumDetail'
import Saved from '../components/user/Saved'
import AccountProfile from '../components/user/AccountProfile'
import AccountPayment from '../components/user/AccountPayment'
import BookingPrevious from '../components/user/BookingPrevious'

export default {
  path: '/user',
  component: MainLayout,
  meta: {
    login: true,
    loginType: 'user'
  },
  children: [
    {
      path: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'booking',
      component: BookingUpComingEvent,
      meta: {
        title: 'Booking',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'booking/previous',
      component: BookingPrevious,
      meta: {
        title: 'Booking',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'message',
      component: Message,
      meta: {
        title: 'Message',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'message/:serviceId',
      component: MessageDetail,
      meta: {
        title: 'MESSAGE Detail',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'album',
      component: AlbumLIsts,
      meta: {
        title: 'Album',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'album/detail/:albumId',
      component: AlbumDetail,
      meta: {
        title: 'Album Detail',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'saved',
      component: Saved,
      meta: {
        title: 'Saved',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'account',
      component: AccountProfile,
      meta: {
        title: 'Account Profile',
        login: true,
        loginType: 'user'
      }
    },
    {
      path: 'account/payment',
      component: AccountPayment,
      meta: {
        title: 'Account Payment',
        login: true,
        loginType: 'user'
      }
    }
  ]
}
